module.exports = __webpack_public_path__ + "static/media/hero-painting-on-canvas.f918f88e.jpg";